/* @flow */
/* eslint-disable babel/no-invalid-this */
import Dispatch from "nexia_mobile/flux_like/dispatch";
import type { UnlockLockFeature } from "./types";

export default function UnlockLock(feature: UnlockLockFeature) {
  let unlockAction = feature.actions.unlock;

  this.unlock = () => {
    const promiseWithAbort = this.executeDeviceAction(unlockAction, {});

    promiseWithAbort.then(() => {
      Dispatch("DEMO_MODE_EVENT", this, "Unlocked");
    });

    return promiseWithAbort;
  };

  return { isUnlocked: feature.is_unlocked };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/unlock_lock.js